import { Injectable, Injector } from '@angular/core';
import { Policy } from '../../../../common/js/customer/Policy';
import { AmorphicService } from '../amorphic/amorphic.service';
import { WorkflowHelperInterface } from '../../interfaces/helper/WorkflowHelperInterface';

import { WorkflowStateType } from '../../../js/interfaces/CoverpathTypes';
import { Assumptions } from '../../../../common/js/static/Assumptions';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  workflowHelper: WorkflowHelperInterface;

  constructor(private amorphicService: AmorphicService) {
    this.workflowHelper = this.amorphicService.controller.workflowHelper;
  }

  isPreSubmit(): boolean {
    const primaryPolicy = this.amorphicService.controller.customer.application?.primaryPolicy;
    return primaryPolicy && !primaryPolicy.submittedAt;
  }

  getWorkflowStateFromPolicy(policy: Policy): string {
    if (!policy) {
      return null;
    }

    if (policy.futureWorkflowState) {
      return policy.futureWorkflowState;
    } else {
      return policy.workflowState;
    }
  }

  getWorkflowSubStateFromPolicy(policy: Policy): string {
    if (!policy) {
      return null;
    }

    if (policy.futureWorkflowSubState) {
      return policy.futureWorkflowSubState;
    } else {
      return policy.workflowSubState;
    }
  }

  cancelApplication(policy: Policy) {
    const futureState = 'Application Canceled By User';
    const futureSubState = 'Without TLIC';
    const controller = this.amorphicService.controller;
    return controller.checkRequirement(policy, 'Cancel', futureSubState, futureState);
  }

  async getWorkflowStateAndSubStateFromPolicyNumber(policyNumber: string): Promise<WorkflowStateType> {
    return this.workflowHelper.getWorkflowStateAndSubStateFromPolicyNumber(policyNumber);
  }

  async getWorkflowActivityResult(policy: Policy, stage: string): Promise<string> {
    return this.workflowHelper.getWorkflowActivityResult(policy, stage);
  }
}
